import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IExceptionSearchModel } from '../../../models/index';
import { GetExceptionState } from '../../actions/types/exceptions/FetchExceptionTypes';

/**
 * Initial Event state in store
 */
const initialState: GetExceptionState = {
  isLoading: false,
  eventErrorMessage: '',
  exceptions: []
};

const fetchExceptionSlice = createSlice({
  name: 'fetchException',
  initialState,
  reducers: {
    fetchExceptionStarted: (state) => {
      state.isLoading = true;
    },

    fetchExceptionSuccess: (state, action: PayloadAction<IExceptionSearchModel[]>) => {
      state.isLoading = false;
      state.exceptions = action.payload;
      state.eventErrorMessage = '';
    },

    fetchExceptionFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.exceptions = initialState.exceptions;
      state.eventErrorMessage = action.payload;
    },

    clearExceptionDetails: (state) => {
      state.isLoading = false;
      state.exceptions = initialState.exceptions;
      state.eventErrorMessage = '';
    }
  }
});
export const {
  fetchExceptionStarted,
  fetchExceptionSuccess,
  fetchExceptionFail,
  clearExceptionDetails
} = fetchExceptionSlice.actions;
export default fetchExceptionSlice.reducer;
